import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";
const scanErro = require('../../../public/audio/ScanErro.wav')
const scanOk = require('../../../public/audio/scanOk.wav')

export default {
	namespaced: true,
	state: {
		lstVdk: [],
		vdk: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		since: moment().format("YYYY-MM-DD"),
		until: moment().format("YYYY-MM-DD"),
		carts: [],
		selectedPr0: null,
		consigned: false,
		loadingTaxes: false,
		docfis: "",
		baseIcmAmount: 0,
		valIcmAmount: 0,
		docReturn: null,
		dialogNFThird: false,
		emispro: true, 
		savedVDK: false,
		consignmentAmount: 0,
		hasEspecialPermission: false,
		tabVdItem: 0,
		selectedPr0OriginalQtde: 0,
		managerApproval: false,
	},
	getters: {
		amountReturn(state){
			let amount = 0
			const itemsAmount = (accumulator, item) => accumulator + item.total
			for (const cart of state.carts) {
				amount += cart.lstItems.reduce(itemsAmount, 0)
			}
			return amount
		},
		amountReturnSales(state){
			let amount = 0
			const itemsAmount = (accumulator, item) => accumulator + item.total
			const filterOnlySales = (item) => !item.consigned
			for (const cart of state.carts) {
				if (!state.consigned)
					amount += cart.lstItems.filter(filterOnlySales).reduce(itemsAmount, 0)
			}
			return amount
		},
		amountReturnConsigned(state){
			let amount = 0
			const itemsAmount = (accumulator, item) => accumulator + item.total
			const filterOnlySales = (item) => item.consigned
			for (const cart of state.carts) {
				if (state.consigned)
					amount += cart.lstItems.reduce(itemsAmount, 0)	
				else
					amount += cart.lstItems.filter(filterOnlySales).reduce(itemsAmount, 0)
			}
			return amount
		},
		qtyItems(state){
			let qty = 0
			const itemsQty = (accumulator, item) => accumulator += (item.qtde ? item.qtde : 0)
			for (const cart of state.carts) {
				qty += cart.lstItems.reduce(itemsQty, 0)
			}
			return qty
		},
		qtyItemsSales(state){
			let qty = 0
			const itemsQty = (accumulator, item) => accumulator += (item.qtde ? item.qtde : 0)
			const filterSales = item => !item.consigned
			for (const cart of state.carts) {
				qty += cart.lstItems.filter(filterSales).reduce(itemsQty, 0)
			}
			return qty
		},
		qtyItemsConsignment(state){
			let qty = 0
			const itemsQty = (accumulator, item) => accumulator += (item.qtde ? item.qtde : 0)
			const filterConsignment = item => item.consigned
			for (const cart of state.carts) {
				qty += cart.lstItems.filter(filterConsignment).reduce(itemsQty, 0)
			}
			return qty
		},
		vdkmodel(state){
			return {
				vdk: state.vdk,
				carts: state.carts,
				lstItems: [],
				printReceipt: false,
				docfis: state.docfis,
				docReturn: state.docReturn,
				emispro: state.emispro
			}
		},
		carts(state){
			let carts = []
			for (const cart of state.carts) {
				let lstItems = JSON.parse(JSON.stringify(cart.lstItems))
				for (const vditem of lstItems) {
					vditem.eancodigo = vditem.vdxpeca
					vditem.of3peca = vditem.vdlpeca
				}
				carts.push({
					lstItems,
					volume: cart.volume,
					vdkcliente: cart.vdkcliente,
					headers: cart.headers
				})
			}
			return carts
		},
		docReturn(state){
			let docReturn;
			if (state.docReturn){
				docReturn =  {...state.docReturn}
				docReturn.cv5emissao = Utils.ParseToDate(docReturn.cv5emissao)
				docReturn.cv5emissao = moment(docReturn.cv5emissao).format("YYYY-MM-DDTHH:mm:ssZ");
			}
			return docReturn
		},
		getVdkcliente(state){
			return state.vdk.vdkcliente
		},
		getTabVdItem(state){
			return state.tabVdItem
		},
		getVdkclienteByTabVdItem(state){
			return state.carts[state.tabVdItem].vdkcliente
		},
		getConsigned(state){
			return state.consigned
		},
		getManagerApproval(state){
			return state.managerApproval
		}
	},
	mutations: {
		set(state, vdk){
			state.vdk = vdk
			if (vdk.vdkdoc)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.vdk = null
			state.carts = []
			state.selectedPr0 = null
			state.consigned = false
			state.loadingTaxes = false
			state.docfis = ""
			state.baseIcmAmount = 0
			state.valIcmAmount = 0,
			state.dialogNFThird= false
			state.emispro = true
			state.savedVDK = false
			state.docReturn = null
			state.consignmentAmount = 0
			state.hasEspecialPermission = false
			state.tabVdItem = 0
			state.selectedPr0OriginalQtde = 0
			state.managerApproval = false
		},
		setParamsDataTable(state, payload){
			state.lstVdk = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setManagerApproval(state, managerApproval){
			state.managerApproval = managerApproval
		}
	},
	actions: {
		setManagerApproval({ commit }, managerApproval){
			commit("setManagerApproval", managerApproval)
		},
		set(store, vdk){
			store.commit("set", vdk)
		},
		initForm(store){
			store.commit("initForm")
		},
		clear(store){
			store.dispatch("init", {
				"vdkdoc": "",
				"vdkcliente": "",
				"vdkmotivo": "",
				"vdkusuario": "",
				"vdkmanter": false,
				"vdkabert": new Date(),
				"vdkobserva": "",
				"vdktipo": "",
			})
		},
		init(store, vdk){
			store.state.vdk = vdk
			store.state.carts = []
			store.state.insert = true
			store.dispatch("getHeaderByLxdEan")
			.then(headers => {
				store.state.carts = [{
					lstItems: [],
					volume: "1",
					vdkcliente: vdk.vdkcliente,
					headers
				}]
			})
		},
		async find(store, vdkdoc){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get(`/Return/Return/Find/${vdkdoc}`)
			.then(response => {
				let vdk = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", vdk)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
		},
		async recover(store, vdkdoc){
			let lxd = store.rootState.lxd.lxd
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Recuperando devolução", indeterminate: true }, {root: true})
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Return/Return/Recover/${vdkdoc}`)
			.then(response => {
				let saveReturnModel = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", saveReturnModel.vdk)
				for (const item of saveReturnModel.lstItems) {
					item.vdxpeca = item.eancodigo
					item.vdlpeca = item.of3peca
				}
				store.dispatch("getHeaderByLxdEan")
				.then(headers => {
					store.state.carts = [{
						lstItems: saveReturnModel.lstItems,
						volume: "1",
						vdkcliente: saveReturnModel.vdk.vdkcliente,
						headers
					}]
				})
				store.dispatch("calculateTaxes")
				store.state.savedVDK = true
				store.state.consigned = lxd.lxdmoddev == 1 ? false : lxd.lxddocdev2 == saveReturnModel.docfis
				store.state.docfis = saveReturnModel.docfis
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message,
					cancelAction: () => router.push("/oryxpdv/devolucoes")
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		getHeaderByLxdEan(store){
			if (store.rootState.lxd.lxd.lxdean) {
				return [
					{ text: 'vdxpeca', align: 'left', value: 'vdxpeca' },
					{ text: 'pr0produto', value: 'pr0produto' },
					/* { text: 'pr0desc', value: 'pr0desc' },
					{ text: 'pr2opcao', value: 'pr2opcao' },
					{ text: 'pr3tamanho', value: 'pr3tamanho' }, */
					{ text: "NF", value: "doc"},
					{ text: "Item NF", value: "cv7itemrefe"},
					{ text: "Dt emissão", value: "emissao"},
					{ text: 'vdxpreco', value: 'preco' },
					{ text: 'Desconto', value: 'descon' },
					{ text: "Preço com desc.", value: "precodesc"},
					{ text: 'vdxqtde', value: 'qtde' },
					{ text: 'Total', value: 'total' },
				]
			}
			return [
				{ text: 'vdlpeca', align: 'left', value: 'vdlpeca' },
				{ text: 'pr0produto', value: 'pr0produto' },
			/*  { text: 'pr0desc', value: 'pr0desc' },
				{ text: 'pr2opcao', value: 'pr2opcao' },
				{ text: 'pr3tamanho', value: 'pr3tamanho' }, */
				{ text: "NF", value: "doc"},
				{ text: "Item NF", value: "cv7itemrefe"},
				{ text: "Dt emissão", value: "emissao"},
				{ text: 'vdlpreco', value: 'preco' },
				{ text: 'Desconto', value: 'descon' },
				{ text: "Preço com desc.", value: "precodesc"},
				{ text: 'Total', value: 'total' },
				{ text: '', value: 'consigned' },
			]
		},
		async save(store, printReceipt){
			if (store.state.update){
				store.dispatch("update", printReceipt)
				return
			}
			
			store.dispatch("insert", printReceipt)
		},
		async insert(store, printReceipt){
			let vdkmodel = store.getters.vdkmodel
			vdkmodel.printReceipt = printReceipt
			vdkmodel.carts = store.getters.carts
			vdkmodel.docReturn = store.getters.docReturn

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gravando devolução", indeterminate: true }, {root: true})
			
			let lastCart = vdkmodel.carts[vdkmodel.carts.length -1].volume

			for (const cart of vdkmodel.carts) {
				vdkmodel.lstItems = cart.lstItems
				vdkmodel.vdkcliente = cart.vdkcliente
				let payload = await this._vm.$axios.post("/Return/Return/Insert", vdkmodel )
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					store.state.vdk.vdkdoc = payload.vdk.vdkdoc
					store.state.savedVDK = payload.savedVDK

					if (payload.isError || (lastCart === cart.volume && !payload.isError)) {
						store.dispatch("parameters/openDialog", {
							titleText: payload.isError ? "Erro" : payload.message,
							titleColor: payload.isError ? "red" : "green",
							text: payload.isError ? payload.message : "",
							cancelAction: () => {
								if (!payload.isError) {
									if (store.state.consigned) {
										setTimeout(() => {
											store.dispatch("parameters/openDialog", {
												titleText: "Acerto de consignado",
												titleColor: "#17a2b8",
												text: "Deseja realizar o acerto do consignado?",
												confirmBtn: true,
												confirmText: "Sim",
												confirmAction: () => router.push({ path: "/oryxpdv/novo-confirmacao-venda", query:{ cf1cliente: store.state.vdk.vdkcliente }}),
												cancelText: "Não",
												cancelAction: () => router.push("/oryxpdv/devolucoes")
											}, { root: true })    
										}, 500);
									}else{
										router.push("/oryxpdv/devolucoes")
									}
								}
							}
						}, { root: true })
					}
					
					if(!payload.isError && payload.relatsPath && payload.relatsPath.length > 0){
						store.dispatch("print/openRelatsPath", payload.relatsPath , { root: true })
					}
	
					return !payload.isError
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});

				if (!payload) {
					break
				}
			}
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async update(store, printReceipt){
			let vdkmodel = store.getters.vdkmodel
			vdkmodel.printReceipt = printReceipt
			vdkmodel.carts = store.getters.carts
			vdkmodel.docReturn = store.getters.docReturn

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Gravando devolução", indeterminate: true }, {root: true})

			let lastCart = vdkmodel.carts[vdkmodel.carts.length -1].volume

			for (const cart of vdkmodel.carts) {
				vdkmodel.lstItems = cart.lstItems
				vdkmodel.vdkcliente = cart.vdkcliente

				let payload = await this._vm.$axios.put("/Return/Return/Update", vdkmodel )
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data);
					store.state.vdk.vdkdoc = payload.vdk.vdkdoc
					store.state.savedVDK = payload.savedVDK

					if (payload.isError || (lastCart === cart.volume && !payload.isError)) {
						store.dispatch("parameters/openDialog", {
							titleText: payload.isError ? "Erro" : payload.message,
							titleColor: payload.isError ? "red" : "green",
							text: payload.isError ? payload.message : "",
							cancelAction: () => {
								if (!payload.isError) {
									if (store.state.consigned) {
										setTimeout(() => {
											store.dispatch("parameters/openDialog", {
												titleText: "Acerto de consignado",
												titleColor: "#17a2b8",
												text: "Deseja realizar o acerto do consignado?",
												confirmBtn: true,
												confirmText: "Sim",
												confirmAction: () => router.push({ path: "/oryxpdv/novo-confirmacao-venda", query:{ cf1cliente: store.state.vdk.vdkcliente }}),
												cancelText: "Não",
												cancelAction: () => router.push("/oryxpdv/devolucoes")
											}, { root: true })    
										}, 500);
									}else{
										router.push("/oryxpdv/devolucoes")
									}
								}
							}
						}, { root: true })
					}
					
					if(!payload.isError && payload.relatsPath && payload.relatsPath.length > 0){
						store.dispatch("print/openRelatsPath", payload.relatsPath , { root: true })
					}
	
					return !payload.isError
				})
				.catch((error) => {
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
					return false
				});

				if (!payload) {
					break
				}
			}
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async search(store, { limit = 20, page = 1, orderBy = "DESC" }){
			store.state.loading = true
			store.commit("initForm")
			let url = `/Return/Return/Search?search=${store.state.search}&limit=${limit}&page=${page}&orderBy=${orderBy}`
			if (store.state.since) {
				url+= `&since=${store.state.since}`
			}
			if (store.state.until) {
				url+= `&until=${store.state.until}`
			}
			let payload = await this._vm.$axios.get(url)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstVdk = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async findItemsByCustomer(store, cf1cliente){
			return await this._vm.$axios.get(`/Return/Return/FindItemsByCustomer/${cf1cliente}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			});
		},
		addVdItem(store, { pr0, prefix, silent }){
			var audio = new Audio(scanOk);
			var audioErro

			//pegando o volume
			let cart = store.state.carts[store.state.tabVdItem]
			let firstCart = store.state.carts.filter(c => c.vdkcliente == cart.vdkcliente)[0]
			if (cart) {
				// necessário fazer essa regra para conseguir devolver as peças corretamente caso seja o mesmo cliente nos dois carrinhos
				if (cart.volume != firstCart.volume) {
					if(!silent){
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: "Realize a leitura das peças de troca no carrinho " + firstCart.volume + " do cliente"
						}, { root: true })
					
						audioErro = new Audio(scanErro);
						audioErro.play();
					}
					return false
				}
				if (prefix == "vdx"){
					let item = cart.lstItems.filter(v => {
						return v.pr0produto == pr0.pr0produto &&
							v.pr2opcao == pr0.pr2opcao &&
							v.pr3tamanho == pr0.pr3tamanho &&
							v.vdxpeca == pr0.vdxpeca &&
							v.preco == pr0.preco &&
							v.descon == pr0.descon &&
							v.vdedoc == pr0.vdedoc &&
							v.consigned == pr0.consigned
						})[0]
	
					if (item){
						item.qtde += pr0.qtde
						item.vdxqtdeent += pr0.vdxqtdeent
						//calculando o total da linha
						item.total = Math.round(item.qtde * item.precodesc * 100) / 100;
						store.dispatch("calculateTaxes")
	
						if(!silent)
							audio.play();
				
						return true
					}
				}else{
					for (const volume of store.state.carts) {
						if(volume.lstItems.filter(v => v.vdlpeca == pr0.vdlpeca).length > 0){
							if(!silent){
								store.dispatch("parameters/openDialog", {
									titleText: "Erro",
									titleColor: "red",
									text: "Produto já incluído"
								}, { root: true })
							
								audioErro = new Audio(scanErro);
								audioErro.play();
							}
							
							return false
						}
					}
				}
				//calculando o total da linha
				pr0.total = parseFloat((pr0.precodesc).toFixed(2) * pr0.qtde)
				//adicionando no volume
				cart.lstItems.unshift({
					"pr0imagem": pr0.pr0imagem,
					"pr0produto": pr0.pr0produto,
					"pr0desc": pr0.pr0desc,
					"pr2opcao": pr0.pr2opcao,
					"pr3tamanho": pr0.pr3tamanho,
					"qtde": pr0.qtde,
					"preco": pr0.preco,
					"total": pr0.total,
					"vdxpeca": pr0.vdxpeca,
					"vdlpeca": pr0.vdlpeca,
					"leitura": moment(new Date()).format("YYYY-MM-DDTHH:mm:ssZ"),
					"doc": pr0.doc,
					"cv7itemrefe": pr0.cv7itemrefe,
					"cv5tiporefe": pr0.cv5tiporefe,
					"cv5emissorrefe": pr0.cv5emissorrefe,
					"lstCv7Options": pr0.lstCv7Options,
					"volume": pr0.volume,
					"descon": pr0.descon,
					"precodesc": pr0.precodesc,
					"taxes": pr0.taxes,
					"vdedoc": pr0.vdedoc,
					"gravou": false,
					"vdxqtdeent": pr0.vdxqtdeent,
					"consigned": pr0.consigned,
					"rfid": pr0.rfid,
					"cr1nome": pr0.cr1nome,
					"priceList": pr0.preco,
					"originalDiscount": pr0.descon,
					"emissao": pr0.emissao,
					"cv5emissao": pr0.cv5emissao,
					"precoOriginal": pr0.precoOriginal,
					"managerApproval": pr0.managerApproval,
					"modeloFiscal": pr0.modeloFiscal,
				})
	
				if(!silent)
					audio.play();
	
				store.dispatch("calculateTaxes")
				return true
			}
			return false
		},
		changeSelectedPr0(store, vditem){
			store.state.selectedPr0 = vditem
		},
		calculateTaxes(store){
			let baseIcmAmount = 0
			let valIcmAmount = 0
			let icmsIpi = false
			let lx3 = store.rootState.lx3.lx3
			
			for (const cart of store.state.carts) {
				for (const vditem of cart.lstItems) {
					if (vditem.taxes){
						if (vditem.taxes.cfop.startsWith("3"))
							icmsIpi = true
						else
							icmsIpi = lx3.Lx3icmsipi
						
						vditem.taxes.baseicm = (vditem.total + (icmsIpi ? vditem.taxes.ipi : 0)) * (vditem.taxes.baseicp / 100);
		
						vditem.taxes.valicm = parseFloat((vditem.taxes.baseicm * (vditem.taxes.aliqicm / 100)).toFixed(2))
						vditem.taxes.valicm = parseFloat((vditem.taxes.valicm * (1 - (vditem.taxes.pdif / 100))).toFixed(2))
		
						baseIcmAmount+=vditem.taxes.baseicm
						valIcmAmount+=vditem.taxes.valicm
					}
				}
			}

			store.state.baseIcmAmount = baseIcmAmount
			store.state.valIcmAmount = valIcmAmount
		},
		setHeaderInfos(store, { vdkcliente, isSales, vd1repres }){
			if (vdkcliente && !store.state.vdk.vdkcliente) {
				store.state.vdk.vdkcliente = vdkcliente
				if(isSales) {
					store.rootState.vd1.vd1.vd1cliente = vdkcliente
					store.rootState.vd1.vd1.vd1repres = vd1repres
				}	
			}
		},
		async print(store, { vdkdoc, docfis = "", printReceipt = false, download = false}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: `${download ? "Baixando documentos da": "Imprimindo"} devolução ${vdkdoc}` , indeterminate: true }, {root: true})
			await this._vm.$axios.post(`/Return/Return/Print/${vdkdoc}?printReceipt=${printReceipt}&docfis=${docfis}`)
			.then(response => {
				let relatsPath = Utils.ValidateAxiosResponse(response.data);

				if(relatsPath){
					if(download)
						store.dispatch("print/downloadFile", [ relatsPath ], { root: true })
					else
						store.dispatch("print/openRelatsPath", [ relatsPath ], { root: true })
				}

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return true
		},
		async validateConsignment(store, { amountReturnConsignment, filters, confirmAction, setEspecialPermission = true }){
			let lxd = store.rootState.lxd.lxd

			//buscar se possui consignados em aberto
			await store.dispatch("consignment/findMaxReturnConsignmentAmount", { customer: store.state.vdk.vdkcliente }, { root: true })
			.then(amount => {
				store.state.consignmentAmount = amount
				return true
			})

			for (const cart of store.state.carts) {
				if (lxd.lxdean){
					if (lxd.lxdmoddev) {
						amountReturnConsignment += cart.lstItems.filter(item => item.consigned).reduce((accumulator, item) => accumulator + item.total,0);
					}else{
						if(store.state.consigned)
							amountReturnConsignment += cart.lstItems.reduce((accumulator, item) => accumulator + item.total,0);
						else
							amountReturnConsignment = 0
					}
				}
				else{
					amountReturnConsignment += cart.lstItems.filter(item => item.consigned).reduce((accumulator, item) => accumulator + item.total,0);
				}
			}
			
			if(amountReturnConsignment > 0 && amountReturnConsignment > store.state.consignmentAmount && !store.state.hasEspecialPermission)
			{
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: `Valor de peças devolvidas em consignado ${filters.money(amountReturnConsignment)} excede o percentual máximo permitido ${filters.money(store.state.consignmentAmount)}(${filters.percent(lxd.lxdcomadev)})`,
					cancelText: "Autorizar",
					cancelAction: () => {
						store.dispatch("parameters/openManagerDialog", {
							confirmAction: confirmAction,
							dc0arquivo: "VDE",
							permission: "DC5ESPECIA"
						}, { root: true })
					},
					confirmBtn: true,
					confirmText: "Ok"
				}, { root: true })
				return false
			}

			if(setEspecialPermission)
				store.state.hasEspecialPermission = false
			return true
		},
		exportPieces(store, byFiscalModel = false){
			let lxd = store.rootState.lxd.lxd
			let prefix = lxd.lxdean ? "vdx" : "vdl"
			
			let items = store.state.carts[store.state.tabVdItem].lstItems
			
			let arrayLstItems = []
			
			if (byFiscalModel) {
				let lstCv5modelo = [...new Set(items.map(vditem => vditem.modeloFiscal))]
				for (const model of lstCv5modelo) {
					arrayLstItems.push(items.filter(vditem => vditem.modeloFiscal === model))
				}
			}else{
				arrayLstItems.push(items)
			}

			for (const lstItems of arrayLstItems) {
				let text = ""
				for (const item of lstItems.filter(item => !!item[prefix+"peca"])) {
					if(prefix == "vdx"){
						if (item.vdxqtdeent > 0) {
							for (let index = 0; index < item.vdxqtdeent; index++) {
								text += `${item[prefix+"peca"]}\n`
							}
						}else{
							for (let index = 0; index < item.qtde - item.vdxqtdeent; index++) {
								text += `${item[prefix+"peca"]}\n`
							}
						}
					}else{
						text += `${item[prefix+"peca"]}\n`
					}
				}
				if(prefix == "vdx"){
					for (const item of lstItems.filter(item => !item[prefix+"peca"])) {
						if (item.vdxqtdeent > 0) {
							for (let index = 0; index < item.vdxqtdeent; index++) {
								text += `${item.pr0produto}\n`
							}
						}else{
							for (let index = 0; index < item.qtde - item.vdxqtdeent; index++) {
								text += `${item.pr0produto}\n`
							}
						}
					}
				}
	
				if(!text)
					return

				let cv5modelo = lstItems[0].modeloFiscal
				var element = document.createElement('a');
				element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
				element.setAttribute('download', `pecas_${byFiscalModel ? "MODELO_"+cv5modelo+"_" : ""}${(new Date()).getTime()}.txt`);
	
				element.style.display = 'none';
				document.body.appendChild(element);
	
				element.click();
	
				document.body.removeChild(element);
			}
		},
		async changeCustomer(store, { vdkcliente, isSales = false, tabVdItem = 0}){
			var audio = new Audio(scanErro);

			let lxd = store.rootState.lxd.lxd

			store.state.tabVdItem = tabVdItem

			//verificar se o cliente é diferente
			let changedCustomer = !!store.state.carts[tabVdItem].vdkcliente && store.state.carts[tabVdItem].vdkcliente != vdkcliente && !!vdkcliente && ((isSales && (!!store.state.carts[tabVdItem].vdkcliente || (!store.state.carts[tabVdItem].vdkcliente && store.state.carts[tabVdItem].lstItems.length > 0))) || !isSales)
			let removePiecesNotEan = !!store.state.carts[tabVdItem].vdkcliente && store.state.carts[tabVdItem].vdkcliente != vdkcliente && !!vdkcliente && ((isSales && (!!store.state.carts[tabVdItem].vdkcliente || (!store.state.carts[tabVdItem].vdkcliente && ((!lxd.lxdean && store.state.carts[tabVdItem].lstItems.length > 0) || (!!lxd.lxdean && store.state.carts[tabVdItem].lstItems.length > 0))))) || !isSales)		
			if (tabVdItem == 0)
				store.state.vdk.vdkcliente = vdkcliente
			store.state.carts[tabVdItem].vdkcliente = vdkcliente

			if(!changedCustomer)
				return false
			
			let lstItems = store.state.carts[tabVdItem].lstItems
			
			if (!!lxd.lxdean) {
				let lstManagerApproval = []
				let lstEntry = []
				store.state.carts[tabVdItem].lstItems = []

				//revalidar cada peça na devolução
				for (const vditem of lstItems) {
					for (let index = 0; index < vditem.qtde; index++) {
						
						//consultar o EAN ou a REF + COR + TAM
						let peca = vditem.vdxpeca
						if(!peca)
							peca = vditem.pr0produto
						
						let payload = await store.dispatch("pr0/findReturnByCode", 
						{
							product: peca,
							option: vditem.pr2opcao,
							size: vditem.pr3tamanho,
							lstItems: store.state.carts[tabVdItem].lstItems,
							qty: 1,
							isSales,
							revalidate: true,
							silent: true
						}, { root: true})
						
						let itemCopy = JSON.parse(JSON.stringify(vditem))
						itemCopy.qtde = 1
						if (payload == false) {
							//sem saldo ou erro
							lstEntry.push(itemCopy)
						}
						else if (payload == null) {
							//produto com saldo mas que extrapolou a data de troca
							lstManagerApproval.push(itemCopy)
						}
						else{
							//produto com saldo
							//adicionar peças a devolução novamente
							payload.qtde = 1
							store.dispatch("addVdItem", { pr0: payload, prefix: "vdx", silent: true })
						}
					}
				}
				
				//função para processamento de item devolvido
				let processVdItem = async (vditem, managerApproval) => {
					let payload = await store.dispatch("pr0/findReturnByCode", 
					{
						product: vditem.pr0produto,
						option: vditem.pr2opcao,
						size: vditem.pr3tamanho,
						lstItems: store.state.carts[tabVdItem].lstItems,
						qty: vditem.qtde,
						isSales,
						input: !managerApproval,
						managerApproval,
						silent: true
					}, { root: true})
					.then(async payloadProduct =>{
						if(payloadProduct){
							payloadProduct.preco = vditem.preco	
							payloadProduct.qtde = vditem.qtde
							payloadProduct.vdxqtdeent = managerApproval ? 0 : vditem.qtde
							payloadProduct.precodesc = payloadProduct.preco
							payloadProduct.total = parseFloat((payloadProduct.preco).toFixed(2) * payloadProduct.qtde)
							
							await store.dispatch("addVdItem", { pr0: payloadProduct, prefix: lxd.lxdean ? "vdx" : "vdl" })
						}
						return true
					})
					return payload
				}

				//processar lista de peças fora do prazo de troca
				let processManagerApprovalList = () => {
					//solicitar a senha de gerente
					//caso aprovado, adicionar produtos à devolução novamente
					let text = "O prazo de troca das peças abaixo por trocas no ano/limite de dias/data de corte esgotou: <br/><ul>"
	
					for (const vditem of lstManagerApproval) {
						text += `<li>Produto: ${vditem.pr0produto} ${vditem.pr0desc} ${!!vditem.pr2opcao ? `Cor: ${vditem.cr1nome}` : ""} ${!!vditem.pr3tamanho ? `tamanho: ${vditem.pr3tamanho}`: ""}</li>`
					}
					text += "</ul>"

					store.rootState.vd1.tabBody = 0
					audio.play();

					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text,
						confirmBtn: true,
						confirmText: "Ok",
						cancelText: "Autorizar",
						cancelAction: () => {
							store.dispatch("parameters/openManagerDialog", {
								showCheckBox: true,
								textCheckBox: "Aplicar para as próximas leituras",
								confirmAction: async () => {
									store.rootState.vdk.managerApproval = store.rootState.parameters.dialogManager.valueCheckBox

									for (const vditem of lstManagerApproval) {
										let payload = await processVdItem(vditem, true)
									}
									
									if(isSales){
										store.dispatch("vd1/calculatevd1vltroca", null, { root: true })
											.then(store.dispatch("vd1/calculateDiscount", null, { root: true })
												.then(store.dispatch("vd1/calculateCv8", {} , { root: true })))
									}
								},
								dc0arquivo: "VDK",
								permission: "DC5ESPECIA"
							}, { root: true })
						}
					}, { root: true })
				}

				//processar lista de peças sem saldo de troca
				if (lstEntry.length > 0) {
					//caso não tenha saldo solicitar se quer dar entrada - chamar a função para dar entrada novamente
					let text = "Cliente não possui saldo de trocas para as seguintes variações de produtos: <br/><ul>"

					for (const vditem of lstEntry) {
						if (!text.includes(`Produto: ${vditem.pr0produto} ${vditem.pr0desc} ${!!vditem.pr2opcao ? `Cor: ${vditem.cr1nome}` : ""} ${!!vditem.pr3tamanho ? `tamanho: ${vditem.pr3tamanho}`: ""}`)) {
							text += `<li>Produto: ${vditem.pr0produto} ${vditem.pr0desc} ${!!vditem.pr2opcao ? `Cor: ${vditem.cr1nome}` : ""} ${!!vditem.pr3tamanho ? `tamanho: ${vditem.pr3tamanho}`: ""}</li>`
						}
					}
					text += "</ul>"
					
					store.rootState.vd1.tabBody = 0
					audio.play();

					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text,
						confirmBtn: lxd.lxdentrdev && (lxd.lxdmoddev || !store.state.consigned) ,
						confirmText: lxd.lxdentrdev && (lxd.lxdmoddev || !store.state.consigned) ? "Ok" : null,
						cancelText: lxd.lxdentrdev && (lxd.lxdmoddev || !store.state.consigned) ? "Entrada" : "Ok",
						cancelAction: async () => {
							if(lxd.lxdmoddev || !store.state.consigned){
								if(lxd.lxdentrdev){
									for (const vditem of lstEntry) {
										let payload = await processVdItem(vditem, false)
									}
									
									if(isSales){
										store.dispatch("vd1/calculatevd1vltroca", null, { root: true })
										.then(store.dispatch("vd1/calculateDiscount", null, { root: true })
										.then(store.dispatch("vd1/calculateCv8", {} , { root: true })))
									}
								}
								if (lstManagerApproval.length > 0) {
									setTimeout(() => {
										processManagerApprovalList()
									})
								}
							}
						},
						confirmAction: async () => {
							if ((lxd.lxdmoddev || !store.state.consigned) && lstManagerApproval.length > 0) {
								setTimeout(() => {
									processManagerApprovalList()
								})
							}
						}
					}, { root: true })
					return true
				} else if ((lxd.lxdmoddev || !store.state.consigned) && lstManagerApproval.length > 0) {
					processManagerApprovalList()
				}

				//
			} else{
				if (store.state.carts[tabVdItem].lstItems.length > 0 && removePiecesNotEan) {
					store.dispatch("exportPieces")
					store.state.carts[tabVdItem].lstItems = []
					store.dispatch("parameters/openDialog", {
						titleText: "Aviso",
						titleColor: "#f8bb86",
						text: `Todas as peças lidas na devolução do romaneio ${tabVdItem+1} foram removidas devido a mudança de cliente. <br/>Por favor revise as parcelas da venda.`
					}, { root: true })
				}
			}
			return true
		}
	}
}
